/**
 * IMPORT CORE DI ANGULAR
 */

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TokenInterceptor } from './_interceptor/token.interceptor';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AuthService } from './_service/auth.service';
import { AuthLoginComponent } from './login/login.component';
import { AuthLogoutComponent } from './logout/logout.component';
import { SharedModule } from '../shared/_service/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guard/auth.guard';

const routes: Routes = [
	{ path: 'login', component: AuthLoginComponent },
	{ path: 'logout', component: AuthLogoutComponent },
];

@NgModule({
	declarations: [AuthLoginComponent, AuthLogoutComponent],
	imports: [SharedModule, RouterModule.forChild(routes)],
	exports: [],
	providers: [
		AuthService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true,
		},
	],
})
export class AuthModule {}
